import _ from 'lodash';
import wrappedFetch from '../base';
import { BROKERAGE_SUPPORTED_BROKERS, facadeBaseUrl } from 'v3/common/configs/facadeConfigs';

export const getBrokerConfig = _.memoize((broker: string) => {
  const formatBrokerName = broker.toUpperCase().replace(/\s+/g, '_');
  if(!BROKERAGE_SUPPORTED_BROKERS.includes(formatBrokerName)){
    return Promise.resolve({brokerageCharges: null});
  }
  const formatBody = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brokerName: formatBrokerName,
      apiMethodName: 'brokerageCharges'
    }),

  }
  return wrappedFetch(`${facadeBaseUrl}`, formatBody)
    .then((response) => response.json())
    .then((result) => result);

}, (broker:string) => broker);
